import { CmsPublicationTargeting } from '../../../../components/Cms';

export function CmsPublicationTarget() {
  return <CmsPublicationTargeting />;
}
